<template>
    <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item label="线路名称" prop="busLinesId" label-width="70px">
          <el-select style="width: 130px;" v-model="busLinesId" filterable clearable placeholder="请选择线路名称">
            <el-option
              v-for="item in busLinesList"
              :key="item.Id"
              :value="item.Id"
              :label="item.LineChineseName"
            >
              <span style="float: left">{{ item.LineChineseName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号" prop="vehicleId" label-width="60px">
          <el-select style="width: 160px;" v-model="vehicleId" filterable clearable placeholder="请选择车牌号">
            <el-option
              v-for="item in vehicleList"
              :key="item.Id"
              :value="item.Id"
              :label="item.LicensePlateNumber"
            >
              <span style="float: left">{{ item.LicensePlateNumber }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机" prop="driverId" label-width="60px">
          <el-select style="width: 120px;" v-model="driverId" filterable clearable placeholder="请选择司机">
            <el-option
              v-for="item in driverList"
              :key="item.Id"
              :value="item.Id"
              :label="item.Name"
            >
              <span style="float: left">{{ item.Name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出车时间" prop="departureDate" label-width="70px">
          <el-date-picker
            style="width:230px"
            v-model="departureDate"
            type="daterange"
            value-format="yyyy-MM-dd" 
            format="yyyy-MM-dd" 
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <!-- 这个就是当前页面内，所有的btn列表 -->
        <el-form-item v-for="item in buttonList" v-bind:key="item.id">
          <!-- 这里触发点击事件 -->
          <el-button :type="item.Func&&(item.Func.toLowerCase().indexOf('handledel')!= -1 ||item.Func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.IsHide" @click="callFunc(item)">{{item.name}}</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </template>
  <script>
  import { getBusLinesListPage, getDriverListPage, getVehiclesListPage } from "../../api/api";
  
  export default {
    name: "TotalDetailsToolbar",
    data() {
      return {
        busLinesList: [], //线路列表
        driverList: [], //驾驶员列表
        vehicleList: [], //车辆列表
        busLinesId:"", //线路ID
        driverId:"", //驾驶员Id
        vehicleId:"", //驾驶员Id
        departureDate: [] //出车时间
      };
    },
    props: ["buttonList"], //接受父组件传值
    methods: {
      callFunc(item) {
        item.busLinesId = this.busLinesId;
        item.driverId = this.driverId;
        item.vehicleId = this.vehicleId;
        item.departureDate = this.departureDate;
        this.$emit("callFunction", item); //将值传给父组件
      },    

      getBusLinesList(pageSizePara){
        getBusLinesListPage(pageSizePara).then(res => {
          this.busLinesList = res.data.response.data;
        });
      },
      getDriverList(){
        let para = {
          companyId: "",
          driverName: "",
          employmentStatus: "",
          page: 1,
          pageSize: 200
        };
        getDriverListPage(para).then(res => {
          this.driverList = res.data.response.data;
        });
      },
      getVehiclesList(){
        let para = {
          companyId: '',
          busLinesId: '',
          licensePlateNumber: '',
          terminalsId: '',
          simId: '',
          page: 1,
          pageSize: 200
        };
        getVehiclesListPage(para).then(res => {
          this.vehicleList = res.data.response.data;
        });
      }
    },
    mounted() {
      let pageSizePara = {
      pageSize: 100
    };
      this.getBusLinesList(pageSizePara);
      this.getDriverList();
      this.getVehiclesList();
    }
  };
  </script>